<template>
  <WhitePage :loading="loading">
    <title-bar>地図</title-bar>
    <!-- <result-nav :eno="$route.params.id"></result-nav> -->
    <div>
      <p>
        到達済みのエリアです。エリアをクリックすると旅人とスポットが表示されます。
      </p>

      <SvgPanZoom 
        :zoomEnabled="true"
        :fit="false"
        :center="false"
        class="map"
        maxZoom="2"
        @svgpanzoom="registerSvgPanZoom"
      >
        <svg :class="{ rt:true, mini:showSideBar }" ref="mapFrame">
          <g>
            <line v-for="link in side.links" :key="link.id"
              :x1="link.src.x" :y1="link.src.y" 
              :x2="link.target.x" :y2="link.target.y" stroke="#CCC" stroke-width="5"
            />
            <area-point v-for="(node, key) in side.nodes" :key="key"
              :x="node.x" :y="node.y"
              :label="node.name"
              :value="node.id"
              @click="showDetail"
              :class="{ now:node.now }"
              :weather="node.weather"
              :lv="node.lv"
              />
          </g>
        </svg>

        <div v-if="showSideBar" class="sidebar">

          <b-card no-body class="mb-1" v-for="spot in side.spot" :key="spot.rid">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle="spot.rid">
                {{ spot.name }}
                <font-awesome-icon v-if="spot.lock" 
                  icon="lock" class="icon fa-1x" />
                <b-badge>{{ (side.inList[spot.rid]||[]).length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse :id="spot.rid" accordion="my-accordion">
              <b-card-body class="p-0">
                <b-container class="p-0">
                  <b-row cols="4" align-h="start" class="p-0">
                    <b-col v-for="(ch,i) in side.inList[spot.rid]" :key="i"
                      style="max-width: 60px"
                    >
                      <router-link :to="'/result/'+ch.eno">
                        <b-img :src="ch.icon||'./img/noimage.png'" width="60px" height="60px" />
                      </router-link>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card-body>
            </b-collapse>
          </b-card>

        </div>

      </SvgPanZoom>
    </div>
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import ResultNav from '@/components/ResultNav'
import SvgPanZoom from 'vue-svg-pan-zoom'
import AreaPoint from './AreaPoint'
export default {
  components: {
    WhitePage,
    TitleBar,
    // ResultNav,
    SvgPanZoom,
    AreaPoint
  },
  data () {
    return {
      loading: false,
      showSideBar: false,
      side: {
        spot: [],
        inList: {},
        nodes: {},
        links: [],
        mapWidth: 0,
        now: null
      },
      svgpanzoom: null,
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      response.field.forEach((v)=>{
        this.$set(this.side.nodes, v.id, {
          id:v.id, name:v.name,
          x:v.x, y:v.y, num:response.inlist[v.id]||0,
          now:!!v.now, weather:v.weather, lv:v.lv
        })
        if(v.now){
          this.side.now = v
          this.svgpanzoom.pan({ 
            x:-this.side.now.x+this.side.mapWidth/2,
            y:-this.side.now.y+250
          })
        }
      })
      response.link.forEach((v,i)=>{
        if(this.side.nodes[v.tid]){
          this.side.links.push({
            id:i, src:this.side.nodes[v.sid], target:this.side.nodes[v.tid]
          })
        }
      })
    },
    showDetail (value) {
      this.showSideBar = true
      store.dispatch('getAreaDetail', value)
        .then((response) => {
          this.side.spot = response.fields
          this.side.inList = response.inlist
        })
      return false
    },
    registerSvgPanZoom(svgpanzoom) {
        this.svgpanzoom = svgpanzoom
    },
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getAreaList', route.params)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    if(!this.$route.params.id){
      this.checkLogin()
    }
  },
  mounted () {
    phina.global.app.currentScene.exit('TitleScene')
    this.side.mapWidth = this.$refs.mapFrame.clientWidth
  },
  watch: {
    '$refs.mapFrame.clientWidth' (val) {
      if(this.side){
        this.side.mapWidth = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  border: 1px solid #000;
  width: calc(100% - 5px);
  height: 500px;
  background-color: #FFF;

  .rt {
    width: 100%;
    height: 100%;
    display: inline-block;

    &.mini{
      width: calc(100% - 260px);
    }

    .now{
      color: #0F0;
    }
  }
}
.sidebar {
  vertical-align: top;
  display: inline-block;
  width: 260px;
  height: 500px;
  border: 1px solid #000;
  overflow-y: scroll;
  overflow-x: hidden;
}
.iconList {
  text-align: left;
}
</style>
